import { Authentication } from '@leedpulse-monorepo/classes';
import HttpClient from '../../../core/HttpClient';

export interface LeedflowNumberHit {
  id: string;
  company_id: string | null;
  api_key: string | null;
  sender: string[];
  id_plan: string | null;
  /** Downsell scheduled for the next billing date */
  pending_plan_change: { id_plan: string; effective_at: number; requested_at: number; requested_by: string } | null;
  plan_name: string | null;
  plan_end: number | null;
  plan_start: number | null;
  status: string | null;
  credit_status: 'ready' | 'warning' | 'exhausted' | 'overage' | null;
  usernames: string[];
  credits_leedbucks: number | null;
  updated: number | null;
}

export interface SearchCompanyNumbersResult {
  hits: LeedflowNumberHit[];
  nbHits: number;
}

async function searchCompanyNumbers(
  { companyId, q = '', page = 0, hitsPerPage = 20, planId, creditStatus }: { companyId: string; q?: string; page?: number; hitsPerPage?: number; planId?: string; creditStatus?: string },
  authentication: Authentication | null,
): Promise<SearchCompanyNumbersResult> {
  if (!authentication) {
    throw new Error('Authentication is required');
  }

  const params = new URLSearchParams({
    q,
    page: String(page),
    hitsPerPage: String(hitsPerPage),
    companyId,
  });
  if (planId) params.append('planId', planId);
  if (creditStatus) params.append('creditStatus', creditStatus);

  const json = await HttpClient.get(
    `/algolia/search/frontendleedflow/numbers?${params.toString()}`,
    authentication.token,
  );

  return { hits: json?.hits ?? [], nbHits: json?.nbHits ?? 0 };
}

export default searchCompanyNumbers;
